import { Button, IconButton, useMediaQuery } from "@mui/material";
// import deleteConfirmIcon from "../../assets/Images/popupDeleteIcon.svg";
import globalStyles from "../../../Styles/global.module.scss";
import styles from "../../../Styles/ComponentStyles/GlobalComponentStyles/WarningDialog.module.scss"

import Grid from '@mui/material/Grid2';
import Icons from "../Icons/Icons";
import GlobalButton from "../GlobalButton/GlobalButton";

interface DeletePopupProps {
    popupTitle?: string;
    popupDescription?: string;
    handleClose?: () => void;
    onDelete?: () => void;
    primaryButtonText?: string | null;
    secondaryButtonText?: string
    primaryButtonWidth?: string
    secondaryButtonWidth?: string
}

export default function GlobalWarningDialog(props: DeletePopupProps) {

    const {
        popupDescription,
        handleClose,
        onDelete,
        popupTitle,
        primaryButtonText,
        secondaryButtonText,
        secondaryButtonWidth,
        primaryButtonWidth
    } = props

    const isBelow414 = useMediaQuery('(max-width : 415px) and (min-width : 0px)');

    return (
        <Grid container
            // className={globalStyles.demo}
            direction={"column"}
            textAlign={"center"}
            justifyContent={"center"}
            sx={{ padding: { sm: "20px", xs: "10px 0px" } }}
        >
            <Grid container >
                <Grid size={{ xs: 12 }} className={`${styles.iconItem}`}>
                    <Icons
                        iconName="warningIcon"
                        iconWidth="150px"
                        iconHeight="150px"
                        iconColor="#FFF7ED"
                    />
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <span className={styles.dialogDesc}>
                        {popupDescription}
                    </span>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <Grid container className={`${styles.buttonContainer}`}>
                        {primaryButtonText !== null &&
                            <Grid sx={{ width: { sm: primaryButtonWidth, xs: isBelow414 ? "90%" : "50%" } }}>
                                <GlobalButton
                                    value={primaryButtonText ? primaryButtonText : ""}
                                    className={styles.primaryButtonStyles}
                                    size="medium"
                                    fullWidth
                                    onClick={onDelete}
                                />
                            </Grid>}
                        <Grid sx={{ width: { sm: secondaryButtonWidth, xs: isBelow414 ? "90%" : "45%" } }}>
                            <GlobalButton
                                size="medium"
                                variant="outlined"
                                className={styles.secondaryButtonStyle}
                                value={secondaryButtonText ? secondaryButtonText : ""}
                                onClick={handleClose}
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
}